import { ComponentPropsWithoutRef, ReactNode, ReactNodeArray } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  table: css`
    border-spacing: 0;
    border: 1px solid var(--border-color-2);
    width: 100%;

    tfoot > tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      height: 40px;
      border-bottom: 1px solid var(--border-color-2);
      border-right: 1px solid var(--border-color-2);
      text-align: center;

      :last-child {
        border-right: 0;
      }

      &.right {
        text-align: right;
      }
      &.left {
        text-align: left;
      }
    }

    th {
      font-size: 12px;
      font-weight: bold;
    }

    td {
      font-size: 13px;
      font-weight: normal;
    }
  `,
}

type StyledTableProps = {
  children: ReactNode | ReactNodeArray
  className?: string
} & ComponentPropsWithoutRef<"table">

export function StyledTable(props: StyledTableProps) {
  const { children, className, ...rest } = props

  return (
    <table className={cx(styles.table, className)} {...rest}>
      {children}
    </table>
  )
}
